import React from 'react'
import styles from './DroppablePage.scss'
import Dropzone from 'react-dropzone'
import {Icon} from 'common/Icon'
import cx from 'classnames'

export class DroppablePage extends React.PureComponent {
  static defaultProps = {
    hint: 'Drag to upload photos',
    multiple: false
  }

  open = () => {
    this._dropzone && this._dropzone.open()
  }

  render () {
    const {className, onDrop, hint, children, multiple} = this.props
    return (
      <Dropzone
        ref={r => { this._dropzone = r }}
        disableClick
        style={{}}
        activeStyle={{}}
        rejectStyle={{}}
        onDrop={onDrop}
        accept='image/*'
        className={cx(styles.DroppablePage, className)}
        multiple={multiple}
        activeClassName={styles.active}
        rejectClassName={styles.reject}>
        {children}
        <div className={styles.hint}>
          <div className={styles.hintInner}>
            <div>
              <Icon className={styles.photoIcon} i='ios-images-outline' />
            </div>
            {hint}
          </div>
        </div>
      </Dropzone>
    )
  }
}
